require("./invoice_data")

// simple component to encapsulate the invoice and charges data
export class InvoiceViewer extends HTMLElement {
  constructor(billing_invoice_id) {
    super();
    this.billing_invoice_id = billing_invoice_id
  }

  cancelEdit(e) {
    e.preventDefault();
    this.remove();
    document.getElementById('invoices_list').style.display = 'initial';
  }

  async connectedCallback() {
    this.innerHTML = 
      `<style>
        
      </style>
      <div class="row">
        <div class="col-12">
          <h3><span id="campaign-back"></span> View Invoice</h3>

          <invoice-data
            billing_invoice_id = ${this.billing_invoice_id}
            previous_selector_id = "invoice_viewer"
          ></invoice-data>

          <div class="row webhook-wizard-actions"> 
            <div class="col-md-6 no-gutters"> 
              <a class="btn btn-outline-secondary" id="close-viewer">Close</a>
            </div>
          </div>
        </div>
      </div>
    `;

    this.querySelector('#campaign-back').addEventListener('click', this.cancelEdit.bind(this));
    this.querySelector('#close-viewer').addEventListener('click', this.cancelEdit.bind(this));
  }
}

customElements.define("invoice-viewer", InvoiceViewer)